import { render, staticRenderFns } from "./ManageStateLayout.vue?vue&type=template&id=2b5a0269"
import script from "./ManageStateLayout.vue?vue&type=script&lang=js"
export * from "./ManageStateLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports